/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

// Elements
import HeroVacancies from 'components/elements/HeroVacancies'
import ButtonDefault from 'components/elements/ButtonDefault'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import ParseContent from 'components/shared/ParseContent'
// import CustomLink from 'components/shared/CustomLink'
import Image from 'components/shared/Image'

// Third Party
import { FaEnvelope, FaFacebookF, FaWhatsapp, FaLinkedinIn, FaTwitter } from 'react-icons/fa'
import { EmailShareButton, FacebookShareButton, WhatsappShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share'



const Content = styled(ParseContent)`
  p {
    text-align: justify;
    line-height: 24px;
  }

  h2 {
    font-family: ${props => props.theme.font.family.secondary};
    font-size: ${props => props.theme.font.size.xxml};
    margin-bottom: 30px;

    @media screen and (max-width: 576px) {
      font-size: ${props => props.theme.font.size.xxl};
    }
  }

  td {
    border: 1px solid #101010;
    padding: 16px;
  }
`

const StyledImage = styled(Image)`
  width: 100% !important;
  height: auto !important;
`

const SocialIcon = styled.a`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: ${(props) => props.theme.color.text.main};
  display: flex;
  justify-content: center;
  margin: auto 12px auto 0;
  padding-top: 10px;
  cursor: pointer;
`

// const PDFButton = styled(CustomLink)`
//   background: #c5c5c5;
//   border: 2px solid #c5c5c5;
//   border-radius: 8px;
//   height: 64px;
//   line-height: 64px;
//   padding: 0 32px;
//   font-size: ${(props) => props.theme.font.size.xm};
//   color: ${(props) => props.theme.color.text.main};
//   text-decoration: none;
//   transition: all 300ms ease;

//   &:hover {
//     text-decoration: none;
//     background: white;
//   }
// `

const Container = styled.div`
  margin-top: -10rem !important;

  @media (max-width: 991px){
    margin-top: -5rem !important
  }
`

const StyledButton = styled(ButtonDefault)`
  font-weight: ${props => props.theme.font.weight.xl};

  @media screen and (max-width: 576px) {
    a {
      font-size: ${props => props.theme.font.size.m};
    }
  }
`

const PageTemplate = ({
  data: {
    page: { title, path, wordpress_id, yoast_meta: yoast, acf },
  },
  location
}) => {
  return (
    <Layout activePage={'/over-vmt/'}>
      <SEO yoast={yoast} path={path} type="article" />

      <HeroVacancies fields={acf.banner} title={title} />

      <Container className="container d-flex justify-content-end mb-3">
        <div>
          <p className="font-size-xm font-weight-xl mb-0 text-md-left text-center mb-sm-0 mb-3 color-contrast">Deel dit bericht</p>
          <div className="d-flex justify-content-center justify-content-md-start flex-wrap">
            <div className="d-flex justify-content-center">
              <EmailShareButton url={location.href}>
                <SocialIcon className="mr-2">
                  <FaEnvelope size={24} color="white" />
                </SocialIcon>
              </EmailShareButton>

              <FacebookShareButton url={location.href}>
                <SocialIcon className="mr-2">
                  <FaFacebookF size={24} color="white" />
                </SocialIcon>
              </FacebookShareButton>
              
              <WhatsappShareButton url={location.href}>
                <SocialIcon className="mr-2">
                  <FaWhatsapp size={24} color="white" />
                </SocialIcon>
              </WhatsappShareButton>
              
              <LinkedinShareButton url={location.href}>
                <SocialIcon className="mr-2">
                  <FaLinkedinIn size={24} color="white" />
                </SocialIcon>
              </LinkedinShareButton>

              <TwitterShareButton url={location.href}>
                <SocialIcon>
                  <FaTwitter size={24} color="white" />
                </SocialIcon>
              </TwitterShareButton>
            </div>
          </div>
        </div>
      </Container>

      <div className="container">
        <div className="row my-lg-5 my-3 py-lg-5 py-3">
          <div className="col-lg-6">
            <Content content={acf.story.description} className="mb-5" />
            <StyledButton to={`/solliciteren?vacature=${title}`}>Solliciteer direct</StyledButton>
          </div>
          <div className="col-lg-6">
            <StyledImage src={acf.story.image} style={{ objectFit: 'contain', width: '100%', height: '100%' }} />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressWpVacancies(wordpress_id: { eq: $wordpress_id }) {
      ...vacancyDetailPreview
    }
  }
`

export default PageTemplate